export function BillingSkeletonLoader() {
  return (
    <div className="animate-pulse space-y-10">
      {/* Plan card skeleton */}
      <div>
        <div className="h-5 w-32 bg-card-hover rounded mb-2" />
        <div className="h-3 w-48 bg-card-hover rounded mb-5" />
        <div className="rounded-card border border-border p-5 bg-card">
          <div className="flex justify-between mb-4">
            <div>
              <div className="h-5 w-28 bg-card-hover rounded mb-2" />
              <div className="h-3 w-20 bg-card-hover rounded" />
            </div>
            <div className="h-8 w-24 bg-card-hover rounded" />
          </div>
          <div className="h-3 w-36 bg-card-hover rounded" />
        </div>
      </div>

      {/* Pricing table skeleton */}
      <div>
        <div className="h-5 w-40 bg-card-hover rounded mb-5" />
        <div className="rounded-card border border-border p-5 bg-card">
          <div className="space-y-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={`skeleton-row-${i.toString()}`} className="flex gap-4">
                <div className="h-4 flex-1 bg-card-hover rounded" />
                <div className="h-4 w-16 bg-card-hover rounded" />
                <div className="h-4 w-16 bg-card-hover rounded" />
                <div className="h-4 w-16 bg-card-hover rounded" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Payment method skeleton */}
      <div>
        <div className="h-5 w-36 bg-card-hover rounded mb-5" />
        <div className="rounded-card border border-border p-5 bg-card flex justify-between">
          <div className="flex gap-4">
            <div className="h-10 w-10 bg-card-hover rounded-lg" />
            <div>
              <div className="h-4 w-32 bg-card-hover rounded mb-1" />
              <div className="h-3 w-24 bg-card-hover rounded" />
            </div>
          </div>
          <div className="h-8 w-24 bg-card-hover rounded" />
        </div>
      </div>

      {/* Invoice skeleton */}
      <div>
        <div className="h-5 w-32 bg-card-hover rounded mb-5" />
        <div className="rounded-card border border-border p-5 bg-card">
          <div className="h-4 w-48 bg-card-hover rounded mb-2" />
          <div className="h-3 w-64 bg-card-hover rounded" />
        </div>
      </div>
    </div>
  );
}
